// TinyMCE's serializer normalizes bytes, so an unconditional blur write-back
// rewrites text.value from a mere click in and out of an untouched item.
export type BlurCommitEditor = { isDirty?: () => boolean } | null | undefined

export const shouldCommitBlurContent = (editor: BlurCommitEditor): boolean => {
  if (!editor || typeof editor.isDirty !== 'function') return true
  return editor.isDirty()
}
